import { isUndefined } from '../utils/isUndefined.js';
import { isNonEmptyString } from '../utils/isNonEmptyString.js';
import { uuid } from '../utils/uuid.js';
import { isValidId } from './isValidId.js';
import { base } from './base.js';

function JsonRpcRequest(method, params, id) {
    if (!(this instanceof JsonRpcRequest)) {
        // @ts-ignore
        return new JsonRpcRequest(method, params, id);
    }
    if (!isNonEmptyString(method)) {
        throw new TypeError('Request method must be a non-empty string');
    }
    base(this);
    this.method = method;
    if (!isUndefined(params)) {
        this.params = params;
    }
    this.id = isValidId(id) ? id : uuid();
}

export { JsonRpcRequest };
